var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_568_22140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59961 4.83478C1.59961 4.37374 1.99872 4 2.49104 4H21.5082C22.0005 4 22.3996 4.37374 22.3996 4.83478C22.3996 5.29582 22.0005 5.66957 21.5082 5.66957H2.49104C1.99872 5.66957 1.59961 5.29582 1.59961 4.83478ZM1.59961 10.4C1.59961 9.93896 1.99872 9.56522 2.49104 9.56522H15.5653C16.0576 9.56522 16.4568 9.93896 16.4568 10.4C16.4568 10.861 16.0576 11.2348 15.5653 11.2348H2.49104C1.99872 11.2348 1.59961 10.861 1.59961 10.4ZM1.59961 15.9652C1.59961 15.5042 1.99872 15.1304 2.49104 15.1304H8.43389C8.92622 15.1304 9.32532 15.5042 9.32532 15.9652C9.32532 16.4263 8.92622 16.8 8.43389 16.8H2.49104C1.99872 16.8 1.59961 16.4263 1.59961 15.9652Z",
    fill: "#FFE500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_568_22140",
    x: 1.59961,
    y: 4,
    width: 20.8008,
    height: 13.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_568_22140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_568_22140",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.5c51cb3a6675527e284d1598b66951cd.svg";
export { ForwardRef as ReactComponent };